import styled from "styled-components";
import { MOBILE_MAX } from "../../styles/authShellMixins";

export const WarningContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  background: transparent;
  z-index: 1;
`;

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-width: 0; /* permite shrink em flex children (ex Firefox) */
`;

export const TabsScrollWrapper = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 56px;
  height: auto;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  z-index: 850;
  isolation: isolate;

  /* Fundo opaco: evita conteúdo “vazando” por cima da barra ao rolar */
  background: var(--app-bg, #0f1a1c);
  background-image: none;
  border-bottom: 2px solid
    ${({ status }) =>
      status === null ? "var(--text-muted)" : "var(--accent-soft)"};
  box-shadow: var(--shadow-sm);
  box-sizing: border-box;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--app-bg-secondary);
    border-radius: 3px;
  }

  @media screen and (max-width: ${MOBILE_MAX}) {
    top: 0;
    min-height: 52px;
    padding-top: 0.15rem;
    /* Compensa padding horizontal do SideContainer no mobile */
    margin-left: -0.75rem;
    margin-right: -0.75rem;
    width: calc(100% + 1.5rem);
  }
`;

export const LinearTabs = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-end;
  min-width: min-content;
  width: 100%;
  margin: 0;
  list-style-type: none;
  padding: 0 16px;
  box-sizing: border-box;
  transition: left 0.3s ease-in-out;

  @media screen and (max-width: ${MOBILE_MAX}) {
    padding: 0 0.65rem;
  }
`;

export const Tab = styled.div`
  position: relative;
  padding: 10px 20px;
  margin-right: 10px;
  margin-top: 10px;
  display: flex;
  padding-left: 15px;
  text-align: right;
  border-radius: 15px 15px 0 0;
  z-index: 1;
  transition: all 0.3s ease-in-out;
  flex-shrink: 0;
  white-space: nowrap;

  color: ${(props) =>
    props.status === null
      ? "var(--text-muted)"
      : props.active
        ? "var(--text-primary)"
        : "var(--text-primary)"};

  background-color: ${(props) =>
    props.status === null
      ? "var(--surface-3)"
      : props.active
        ? "var(--app-bg-secondary)"
        : "var(--app-bg)"};

  border: ${(props) =>
    props.status === null
      ? "1px solid var(--text-muted)"
      : "1px solid var(--app-bg-secondary)"};

  border-bottom: none;

  box-shadow: ${(props) =>
    props.status === null
      ? "var(--shadow-sm)"
      : props.active
        ? "var(--shadow-md)"
        : "var(--shadow-sm)"};

  cursor: ${(props) => (props.status !== null ? "pointer" : "default")};

  &:hover {
    background-color: ${(props) =>
      props.status === null
        ? "var(--surface-3)"
        : props.active
          ? "var(--app-bg-secondary)"
          : "var(--app-bg-secondary)"};

    border: ${(props) =>
      props.status === null
        ? "1px solid var(--text-muted)"
        : "1px solid var(--app-bg-secondary)"};

    color: ${(props) =>
      props.status === null
        ? "var(--text-muted)"
        : props.active
          ? "var(--text-primary)"
          : "var(--text-primary)"};

    border-bottom: none;
  }

  @media screen and (max-width: ${MOBILE_MAX}) {
    padding: 0.55rem 0.85rem;
    margin-right: 0.4rem;
    margin-top: 0.35rem;
    font-size: 0.85rem;
    border-radius: 10px 10px 0 0;
  }
`;

export const TabItem = styled.li`
  position: relative;
  padding: 12px 2px 12px 16px;
  margin: 0 8px -1px 0;
  border: 1px solid var(--border-subtle);
  background: ${(props) =>
    props.active ? "var(--surface-1)" : "var(--surface-2)"};
  border-radius: 8px 8px 0 0;
  transition: all 0.25s;
  cursor: pointer;

  &:hover {
    background: ${(props) =>
      props.active ? "var(--surface-1)" : "var(--surface-1)"};
  }
`;

export const TabLink = styled.a`
  text-decoration: none;
  color: var(--text-primary);
`;

export const CloseTab = styled.a`
  width: 16px;
  height: 16px;
  margin: 0 14px 0 12px;
  padding: 3px;
  border-radius: 16px;
  line-height: 16px;
  text-align: center;

  &:hover {
    background: var(--border-subtle);
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 0;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  min-width: 0;
`;
